import {
  Directive,
  inject,
  Input,
  SimpleChanges,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { SkeletonRectComponent } from './skeleton-rect/skeleton-rect.component';

function random(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

@Directive({ selector: '[skeleton]' })
export class SkeletonDirective {
  private readonly _tpl: TemplateRef<any> = inject(TemplateRef);
  private readonly _vcr: ViewContainerRef = inject(ViewContainerRef);

  @Input('skeleton') isLoading = false;
  @Input('skeletonRepeat') size = 1;
  @Input('skeletonWidth') width: string;
  @Input('skeletonHeight') height: string;
  @Input('skeletonClassName') className: string;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isLoading']) {
      this._vcr.clear();

      if (changes['isLoading'].currentValue) {
        Array.from({ length: this.size }).forEach(() => {
          const ref = this._vcr.createComponent(SkeletonRectComponent);

          Object.assign(ref.instance, {
            width: this.width === 'rand' ? `${random(30, 90)}%` : this.width,
            height: this.height,
            className: this.className,
          });
        });
      } else {
        this._vcr.createEmbeddedView(this._tpl);
      }
    }
  }
}
